module.exports = __webpack_public_path__ + "static/media/rating-star-empty.b471afcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/rating-star-empty.svg
// module id = 748
// module chunks = 0